export const getJobPublishersAPI = "/job-publishers";
export const createJobPublishersAPI = "/job-publishers";
export function getJobPublisherAPI(id) {
  return "/job-publishers/" + id;
}
export function toggleJobPublisherBlockStatusAPI(id) {
  return "/job-publishers/" + id + "/change-block-status";
}
